import React from 'react'
import HR from 'components/HR'
import TrustPilotWidget from 'components/TrustPilot/Widget'
import { InitialLoad } from 'styles/algolia/collection'
import { MainContent } from 'styles/algolia'
import Error from 'apps/error/components/Error'
import LayoutConnector, { ConnectorProps as LayoutProps } from '../connectors/Layout'
import Breadcrumb from '../components/Breadcrumb'
import Header from '../components/Header'
import FacetsLayout from './Facets'
import PaginationHitsPerPageLayout from './PaginationHitsPerPage'
import { ArtworksList } from '../components/artworks'
import { Layout } from '../components/styles'
import CreateCollectionsModal from './Modal'

export default LayoutConnector(
  (props: LayoutProps): React.ReactElement<React.ComponentProps<any>, any> => {
    const { collectionIsPrivate, hasInitialLoad, hasValidPermissions } = props

    // Initial Load, waiting for Session Data ( private collections only )
    if (collectionIsPrivate && !hasInitialLoad) {
      return <InitialLoad>Checking Permissions</InitialLoad>
    }

    // Session is Loaded, but you don't have access
    if (collectionIsPrivate && !hasValidPermissions) {
      return (
        <Error
          hideStatus
          message='The collection you requested is private.'
          text='Browse our featured collections <a href="/collections/browse">here</a>.'
        />
      )
    }

    // Normal Flow
    return (
      <>
        <Layout>
          <Breadcrumb />

          <Header />

          <MainContent>
            <FacetsLayout />
            <ArtworksList />
          </MainContent>
        </Layout>

        <HR />

        <PaginationHitsPerPageLayout />

        <TrustPilotWidget />
      </>
    )
  }
)
